module.exports = __webpack_public_path__ + "assets/img/filter.f44c7af1.svg";